import { useEffect, useState } from 'react';

const getViewportWidth = () =>
  window.innerWidth || document.documentElement.clientWidth;

export const useViewportWidth = (resize = false) => {
  const [viewportWidth, setViewportWidth] = useState(0);

  useEffect(() => {
    setViewportWidth(getViewportWidth());
  }, []);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      if (resize) {
        // debounce can be added to avoid flickering on edge cases
        setViewportWidth(getViewportWidth());
      }
    });

    resizeObserver.observe(document.body, {});

    return () => {
      resizeObserver.disconnect();
    };
  }, [resize]);

  return viewportWidth;
};
